export const constants = {
  lang: 'lang',
  searchTerm: 'Ntt',
  DEFAULT_LAYOUT: 'LIST',
  SESSION_STORAGE_SCROLL: 'scroll',
  SESSION_STORAGE_NEW_PAGE: 'newPage',
  ZONE: {
    DEFAULT_ZONE_ID: '13',
    DEFAULT_ZONE_NAME: 'R. Metropolitana',
  },
  AD_TYPES_FOR_VAS: {
    BRANDS: 'brands',
    PRODUCTS: 'products',
  },
  STORE_NAMES_FOR_VAS: {
    SO_COM: 'so_com',
    TO_COM: 'to_com',
    SODIMAC: 'sodimac',
    TOTTUS: 'tottus',
    LINIO: 'linio',
    TIENDA: 'tienda',
    HOMECENTER: 'homecenter',
  },
  X_CHANNEL_IDS_HEADERS_VALUES: {
    WEB: 'WEB',
    MOBILE: 'MOBILE',
    TABLET: 'TABLET',
  },
  TENANT_TYPES: {
    FALABELLA_CL: 'falabella-cl',
    FALABELLA_CO: 'falabella-co',
    FALABELLA_PE: 'falabella-pe',
    SODIMAC_CL: 'sodimac-cl',
    SODIMAC_PE: 'sodimac-pe',
    SODIMAC_CO: 'sodimac-co',
  },
  COUNTRIES_ABBREVIATIONS: {
    CHILE: 'cl',
    COLOMBIA: 'co',
    PERU: 'pe',
    MEXICO: 'mx',
  },
  SEARCH_REDIRECT_STATUS: 'alt',
  FACETS: {
    CATEGORY_PATH_SEARCH: 'f.product.parentCategoryPaths.pathSearch',
    PRICE_SEARCH_KEY_TOTTUS: 'r.derived.unitPrice',
    PRICE_SEARCH_KEY: 'r.derived.price.search',
    VALUE_TEXT_CHARCOUNT: 50,
  },
  SKIP_LAZY_LOAD_IMAGE_COUNT_MOBILE: 4,
  SKIP_LAZY_LOAD_IMAGE_COUNT_DESKTOP: 8,
  TRACING_HEADERS: [
    'x-request-id',
    'x-b3-traceid',
    'x-b3-spanid',
    'x-b3-parentspanid',
    'x-b3-sampled',
    'x-b3-flags',
    'x-ot-span-context',
  ],
  PAGINATION_TOTAL_RESULTS_LIMIT: 9600,
  DEFAULT_LAYOUT_TYPE: 'HARDLINE',
  PRODUCT_CONSTANTS: {
    HARDLINE: 'HARDLINE',
    SOFTLINE: 'SOFTLINE',
    CONNECT: 'CONNECT',
  },
  HTTP_RES_CODE: {
    TEMP_REDIRECT: 307,
    PERM_REDIRECT: 301,
    NOT_FOUND_CODE: 404,
  },
  DEVICE_DESKTOP: 'desktop',
  DEVICE_MOBILE: 'mobile',
  DEVICE_TABLET: 'tablet',
  PLATFORM_TYPE: {
    ANDROID: 'android',
    IOS: 'ios',
  },
  LAYOUT_2_GRID: '2_GRID',
  LAYOUT_3_GRID: '3_GRID',
  LAYOUT_4_GRID: '4_GRID',
  LAYOUT_1_GRID: '1_GRID',
  LAYOUT_LIST: 'LIST',
  AVAILABILITY_INSTOCK: 'InStock',
  AVAILABILITY_OUTOFSTOCK: 'OutOfStock',
  AVAILABILITY_NETWORKSTOCK: 'Network',
  AVAILABILITY_EXPRESS: 'Express',
  AVAILABILITY_HOMEDELIVERY: 'HomeDelivery',
  PAGES: {
    PDP: 'PDP',
    PLP: 'PLP',
    SLP: 'SLP',
    PLANS: 'PLANS',
    CART: 'CART',
  },
  VIEW_TEMPLATE: {
    TYPE_A: 'TYPE_A',
  },
  DIGITAL_DATA_STORAGE_NAME: 'analyticsInfo',
  WARRANTY_OPTIONS_MIN_ITEM_COUNT_FOR_DROPDOWN: 5,
  MAX_CART_PRODUCT: 999,
  REGEX_1P: /Falabella|Sodimac|Tottus|Linio/gi,
  FALABELLA_REGEX: /falabella/i,
  SODIMAC_REGEX: /sodimac/i,
  HOMECENTER_REGEX: /homecenter/i,
  SO_COM_REGEX: /so_com/i,
  TO_COM_REGEX: /to_com/i,
  TOTUS_REGEX: /tottus/i,
  LINIO_REGEX: /linio_/i,
  FACETS_WITH_SWITCH_REGEX: /(Envío gratis)/i,
  SHIPPING_GROUP_REGEX: /Shipping/,
  EVENT_REGEX: /MULTI_SELECT_EVENT/,
  FREE_SHIPPING_REGEX: /(Envío gratis)/i,
  SWITCH_TOGGLE_REGEX: /(SINGLE_SELECT_STATIC)/i,
  NEXT_DAY_DELIVERY_REGEX: /(Llega mañana)/,
  SAME_DAY_HD_CC_REGEX: /(Llega hoy|Retira hoy|Hoy|\d+ min)/,
  SHIPPING_CC_REGEX: /(Retira hoy|Retira mañana)/,
  HIDDEN_DYNAMIC_FACET_MOBILE: /(SINGLE_SELECT_STATIC)/,
  STORES: {
    sodimac: 'sodimac',
    tottus: 'tottus',
    linio: 'linio',
    tienda: 'tienda',
    homecenter: 'homecenter',
  },
  DECIMAL_SEPARATOR: {
    cl: ',',
    co: ',',
    ar: ',',
    pe: '.',
  },
  DOT_SEPARATOR: {
    cl: '.',
    co: '.',
    ar: '.',
    pe: ',',
  },
  SEO_FRIENDLY_FACETS: [
    'f.product.attribute.Tipo',
    'f.product.brandName',
    'f.variant.custom.Tamaño_de_la_pantalla',
    'f.product.attribute.Capacidad_de_carga',
    'f.product.attribute.Tamaño_del_respaldo',
    'f.product.attribute.Material_del_tapiz',
    'f.product.attribute.Material_de_la_estructura',
    'f.product.attribute.Resolución',
    'f.product.attribute.Procesador',
    'f.product.attribute.Número_de_puestos',
    'f.product.attribute.Aro',
    'f.product.attribute.Número_de_hilos',
    'f.product.attribute.Número_de_puertas',
    'f.product.attribute.Número_de_quemadores',
    'f.product.attribute.Memoria_RAM',
    'f.product.attribute.Tipo_de_piel',
    'f.product.attribute.Tamaño_de_la_pantalla',
    'f.product.attribute.Capacidad_de_lavado',
    'f.derived.product.Tamano_de_la_pantalla',
    'f.product.attribute.Cantidad_de_puertas',
    'f.derived.product.Memoria_RAM',
  ],
  SKIP_FACET_SORTING: ['f.range.derived.product.averageOverallRating'],
  MEDALLIA: 'https://resources.digital-cloud.medallia.com/wdcus/55961/onsite/embed.js',
  GOOGLE_ADS: 'https://securepubads.g.doubleclick.net/tag/js/gpt.js',
  FIT_ANALYTICS: 'https://integrations.fitanalytics.com/shop/falabella/pdp.js',
  DIGITAL_DATA_MANAGER_XLP_SCRIPT: {
    dev: 'https://assets-staging.falabella.com/v3/assets/blt07d653b53a07a055/blt0e1117a5dae9f7bc/xlp.cjs',
    staging: 'https://assets-staging.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/bltf3022ea071e9897c/xlp.cjs',
    beta: 'https://assets-uat.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt4870c50989ab1d66/xlp.cjs',
    www: 'https://assets.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt006a6122094a0f5a/xlp.cjs',
  },
  DIGITAL_DATA_MANAGER_NO_RESULT_SCRIPT: {
    dev: 'https://assets-staging.falabella.com/v3/assets/blt07d653b53a07a055/blt5bfd70100db5c053/noResult.cjs',
    staging: 'https://assets-staging.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blta2518e2baacf2b83/noResult.cjs',
    beta: 'https://assets-uat.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/bltb3b1a8fe31edced4/noResult.cjs',
    www: 'https://assets.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/bltc1b0c6ffbc670416/noResult.cjs',
  },
  VWO_SCRIPTS: {
    cl: 'https://assets.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt3ae1beb67525ed26/vwo.js',
    pe: 'https://assets.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/bltf1762da3c97b64e4/vwo.js',
    co: 'https://assets.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/bltf0b1376d26dd28cc/vwo.js',
  },
  DEFAULT_ZONES: 'AFZone',
  ANDES_DEF_ZONE: {
    politicalId: '15c37b0b-a392-41a9-8b3b-978376c700d5',
    priceGroupId: '96',
    zones: ['ZL_CERRILOS', 'LOSC', '130617', '13'],
    oldZones: ['LOSC', '130617', '13'],
    name: 'Seleccion ubicacion',
  },
  DEF_ZONE: {
    cl: {
      staging: {
        politicalId: '4856187d-c035-45ac-9f4e-9290b9e9f85f',
        priceGroupId: '96',
        zones: ['ZL_CERRILOS', 'LOSC', '130617', '13'],
        name: 'Seleccion ubicacion',
      },
      production: {
        politicalId: 'test',
        priceGroupId: '96',
        zones: [
          'PCL3651',
          'PCL3887',
          'FALABELLA_FBY_BT_SDD',
          'PCL2829',
          'PCL3505',
          'REVERSE_RM_REDPROPIA',
          'PCL2998',
          'PCL3577',
          'HUB_SALIDA_DIRECTA_RM',
          'PCL2120',
          'PCL3687',
          '13_MAIPU',
          'PCL2830',
          'PCL3099',
          'PCL3661',
          'BX_R13_BASE',
          'PCL226',
          'STARKEN_R13',
          'PCL3041',
          'FBY_RM_M',
          'PCL2380',
          'FEDEX_RM_URB',
          'PCL2520',
          'PCL3128',
          'PCL2511',
          'LOSC',
          'PCL540',
          'PCL1386',
          'PCL3136',
          'PCL109',
          '2020',
          'PCL1186',
          'PCL3414',
          '3045',
          'PCL1486',
          'PCL3882',
          'PCL2890',
          '130617',
          'PCL25',
          'CHILEXPRESS_8',
          'PCL1839',
          'PCL1736',
          'FALABELLA_FBY_SDD',
          'PCL2269',
          'ZL_CERRILLOS',
          'PCL1135',
          'PCL3606',
          'PCL3611',
          'RM',
          'PCL108',
          'PCL94',
          'FBY_BT_SALIDA_DIRECTA',
          'PCL2288',
          'CHILE_INTERNATIONAL',
          'PCL1364',
          '13',
          'PCL861',
          'PCL2792',
        ],
        name: 'Seleccion ubicacion',
      },
      uat: {
        politicalId: '15c37b0b-a392-41a9-8b3b-978376c700d5',
        priceGroupId: '96',
        zones: [
          'PCL3651',
          'PCL3887',
          'FALABELLA_FBY_BT_SDD',
          'PCL2829',
          'PCL3505',
          'REVERSE_RM_REDPROPIA',
          'PCL2998',
          'PCL3577',
          'HUB_SALIDA_DIRECTA_RM',
          'PCL2120',
          'PCL3687',
          '13_MAIPU',
          'PCL2830',
          'PCL3099',
          'PCL3661',
          'BX_R13_BASE',
          'PCL226',
          'STARKEN_R13',
          'PCL3041',
          'FBY_RM_M',
          'PCL2380',
          'FEDEX_RM_URB',
          'PCL2520',
          'PCL3128',
          'PCL2511',
          'LOSC',
          'PCL540',
          'PCL1386',
          'PCL3136',
          'PCL109',
          '2020',
          'PCL1186',
          'PCL3414',
          '3045',
          'PCL1486',
          'PCL3882',
          'PCL2890',
          '130617',
          'PCL25',
          'CHILEXPRESS_8',
          'PCL1839',
          'PCL1736',
          'FALABELLA_FBY_SDD',
          'PCL2269',
          'ZL_CERRILLOS',
          'PCL1135',
          'PCL3606',
          'PCL3611',
          'RM',
          'PCL108',
          'PCL94',
          'FBY_BT_SALIDA_DIRECTA',
          'PCL2288',
          'CHILE_INTERNATIONAL',
          'PCL1364',
          '13',
          'PCL861',
          'PCL2792',
        ],
        name: 'Seleccion ubicacion',
      },
    },
    pe: {
      staging: {
        politicalId: 'c6b7a50c-60f3-4687-91d0-9461d538812a',
        priceGroupId: '2',
        zones: ['150000'],
        name: 'Seleccion ubicacion',
      },
      production: {
        politicalId: '799c102f-9b4c-44be-a421-23e366a63b82',
        priceGroupId: '2',
        zones: [
          'PPE3630',
          'IBIS_51',
          'PPE3342',
          'PPE3361',
          'PPE3576',
          'PPE1112',
          'PPE3601',
          '150100',
          'PPE3627',
          'PPE3384',
          'PPE3628',
          '912_LIMA_2',
          'PPE1280',
          '150000',
          'PPE4',
          'PPE3634',
          '912_LIMA_1',
          'PPE1279',
          '150101',
          'PPE344',
          'PPE2485',
          'PPE3059',
          'PPE3629',
          'PPE2492',
          'IMP_2',
          'PPE3331',
          'PPE3357',
          'PPE1091',
          'PERF_TEST',
          'PPE1653',
          'IBIS_99',
          'PPE3578',
          'OLVAA_81',
          'PPE2815',
          'IMP_1',
          'PPE3164',
          '3202',
          'PPE3618',
          'IBIS_110',
          'PPE3659',
          'PPE2918',
          'PPE2681',
          'URBANO_83',
          'PPE2429',
          'PPE3152',
          'PPE3479',
          'PPE3483',
          'PPE3394',
          'PPE2569',
          'LIMA_URB1_DIRECTO',
          'PPE2511',
          'IBIS_19',
          'PPE1382',
        ],
        name: 'Seleccion ubicacion',
      },
      uat: {
        politicalId: '799c102f-9b4c-44be-a421-23e366a63b82',
        priceGroupId: '2',
        zones: [
          'PPE3630',
          'IBIS_51',
          'PPE3342',
          'PPE3361',
          'PPE3576',
          'PPE1112',
          'PPE3601',
          '150100',
          'PPE3627',
          'PPE3384',
          'PPE3628',
          '912_LIMA_2',
          'PPE1280',
          '150000',
          'PPE4',
          'PPE3634',
          '912_LIMA_1',
          'PPE1279',
          '150101',
          'PPE344',
          'PPE2485',
          'PPE3059',
          'PPE3629',
          'PPE2492',
          'IMP_2',
          'PPE3331',
          'PPE3357',
          'PPE1091',
          'PERF_TEST',
          'PPE1653',
          'IBIS_99',
          'PPE3578',
          'OLVAA_81',
          'PPE2815',
          'IMP_1',
          'PPE3164',
          '3202',
          'PPE3618',
          'IBIS_110',
          'PPE3659',
          'PPE2918',
          'PPE2681',
          'URBANO_83',
          'PPE2429',
          'PPE3152',
          'PPE3479',
          'PPE3483',
          'PPE3394',
          'PPE2569',
          'LIMA_URB1_DIRECTO',
          'PPE2511',
          'IBIS_19',
          'PPE1382',
        ],
        name: 'Seleccion ubicacion',
      },
    },
    co: {
      staging: {
        politicalId: '59a6aec4-fc51-4f3b-ab5e-62fd7a1076c0',
        priceGroupId: '10',
        zones: ['14'],
        name: 'Seleccion ubicacion',
      },
      production: {
        politicalId: 'bbea9a06-99b1-44de-bc6e-d314bca4fad3',
        priceGroupId: '10',
        zones: [
          'SERVIENTREGA_10',
          'PCO141',
          'PCO871',
          'PCO749',
          'DEPRISA_52',
          'PCO93',
          'PCO739',
          'ENVIA_79',
          'PCO688',
          'PCO791',
          'PCO1075',
          'ENVIA_68',
          'PCO677',
          'PCO1085',
          'PCO915',
          'ENVIA_1',
          'PCO610',
          'PCO802',
          'SERVIENTREGA_55',
          'PCO186',
          'PCO882',
          'ENVIA_47',
          'PCO656',
          'PCO726',
          'PCO1088',
          'DEPRISA_47',
          'PCO88',
          'PCO920',
          'PCO821',
          'PCO710',
          'PCO1029',
          'PCO762',
          'PCO919',
          'PCO1061',
          'SERVIENTREGA_88',
          'PCO219',
          'PCO892',
          'DEPRISA_55',
          'PCO96',
          'SERVIENTREGA_66',
          'PCO197',
          'PCO948',
          'PCO895',
          'PCO907',
          'PCO516',
          'PCO522',
          'SERVIENTREGA_0',
          'PCO31',
          'TCC_86',
          'PCO311',
          '14',
          'PCO14',
          'ENVIA_53',
          'PCO662',
          'PCO797',
          'PCO753',
          'TCC_66',
          'PCO291',
          'PCO944',
          'PCO807',
          'DEPRISA_40',
          'PCO81',
          'PCO775',
          'DEPRISA_23',
          'PCO64',
          'PCO1067',
          'PCO745',
          'PCO938',
          'PCO800',
          'PCO1113',
          'SERVIENTREGA_5',
          'PCO136',
          'DEPRISA_34',
          'PCO75',
          'TCC_3',
          'PCO228',
          'ENVIA_73',
          'PCO682',
          'PCO1028',
          'PCO764',
          'ENVIA_9',
          'PCO618',
          'TCC_9',
          'PCO234',
          'SERVIENTREGA_39',
          'PCO170',
          'PCO1052',
          'PCO781',
          'PCO1081',
          'SERVIENTREGA_45',
          'PCO176',
          'PCO811',
          'DEPRISA_24',
          'PCO65',
          'TCC_24',
          'PCO249',
          'PCO947',
          'PCO714',
          'PCO900',
          'ENVIA_3',
          'PCO612',
          'PCO865',
          'PCO825',
          'DEPRISA_2',
          'PCO43',
          'PCO794',
          'PCO787',
          'COORDINADORA_87',
          'PCO609',
          'PCO763',
          'SERVIENTREGA_17',
          'PCO148',
          'PCO1112',
          'SERVIENTREGA_25',
          'PCO156',
          '99',
          'PCO326',
          'ENVIA_59',
          'PCO668',
          'DEPRISA_13',
          'PCO54',
          'TCC_78',
          'PCO303',
          'TCC_19',
          'PCO244',
          'PCO880',
          'PCO703',
          'SERVIENTREGA_82',
          'PCO213',
          'IBIS_DIRECTO_BO',
          'PCO704',
          'PCO38',
          'PCO778',
          'PCO1064',
          'ENVIA_6',
          'PCO615',
          'PCO1051',
          'PCO32',
        ],
        name: 'Seleccion ubicacion',
      },
      uat: {
        politicalId: 'bbea9a06-99b1-44de-bc6e-d314bca4fad3',
        priceGroupId: '19',
        zones: [
          'SERVIENTREGA_10',
          'PCO141',
          'PCO871',
          'PCO749',
          'DEPRISA_52',
          'PCO93',
          'PCO739',
          'ENVIA_79',
          'PCO688',
          'PCO791',
          'PCO1075',
          'ENVIA_68',
          'PCO677',
          'PCO1085',
          'PCO915',
          'ENVIA_1',
          'PCO610',
          'PCO802',
          'SERVIENTREGA_55',
          'PCO186',
          'PCO882',
          'ENVIA_47',
          'PCO656',
          'PCO726',
          'PCO1088',
          'DEPRISA_47',
          'PCO88',
          'PCO920',
          'PCO821',
          'PCO710',
          'PCO1029',
          'PCO762',
          'PCO919',
          'PCO1061',
          'SERVIENTREGA_88',
          'PCO219',
          'PCO892',
          'DEPRISA_55',
          'PCO96',
          'SERVIENTREGA_66',
          'PCO197',
          'PCO948',
          'PCO895',
          'PCO907',
          'PCO516',
          'PCO522',
          'SERVIENTREGA_0',
          'PCO31',
          'TCC_86',
          'PCO311',
          '14',
          'PCO14',
          'ENVIA_53',
          'PCO662',
          'PCO797',
          'PCO753',
          'TCC_66',
          'PCO291',
          'PCO944',
          'PCO807',
          'DEPRISA_40',
          'PCO81',
          'PCO775',
          'DEPRISA_23',
          'PCO64',
          'PCO1067',
          'PCO745',
          'PCO938',
          'PCO800',
          'PCO1113',
          'SERVIENTREGA_5',
          'PCO136',
          'DEPRISA_34',
          'PCO75',
          'TCC_3',
          'PCO228',
          'ENVIA_73',
          'PCO682',
          'PCO1028',
          'PCO764',
          'ENVIA_9',
          'PCO618',
          'TCC_9',
          'PCO234',
          'SERVIENTREGA_39',
          'PCO170',
          'PCO1052',
          'PCO781',
          'PCO1081',
          'SERVIENTREGA_45',
          'PCO176',
          'PCO811',
          'DEPRISA_24',
          'PCO65',
          'TCC_24',
          'PCO249',
          'PCO947',
          'PCO714',
          'PCO900',
          'ENVIA_3',
          'PCO612',
          'PCO865',
          'PCO825',
          'DEPRISA_2',
          'PCO43',
          'PCO794',
          'PCO787',
          'COORDINADORA_87',
          'PCO609',
          'PCO763',
          'SERVIENTREGA_17',
          'PCO148',
          'PCO1112',
          'SERVIENTREGA_25',
          'PCO156',
          '99',
          'PCO326',
          'ENVIA_59',
          'PCO668',
          'DEPRISA_13',
          'PCO54',
          'TCC_78',
          'PCO303',
          'TCC_19',
          'PCO244',
          'PCO880',
          'PCO703',
          'SERVIENTREGA_82',
          'PCO213',
          'IBIS_DIRECTO_BO',
          'PCO704',
          'PCO38',
          'PCO778',
          'PCO1064',
          'ENVIA_6',
          'PCO615',
          'PCO1051',
          'PCO32',
        ],
        name: 'Seleccion ubicacion',
      },
    },
    mx: {
      staging: {
        name: 'Seleccion ubicacion',
        comunaName: '10 DE ABRIL',
        politicalId: 'b2557fa3-854b-45d4-8927-1de7ca49062d',
        priceGroupId: '1010',
        zones: [''],
        parentPoliticalId: '0bec7ea1-1d2e-43e0-bc4d-0f982e6d9ebb',
        parentStateId: '6cd56918-f632-41e2-af0d-66bdbde96e6a',
        parentStateName: 'MEXICO',
        latitude: 23.43338300413,
        longitude: -102.267439788865,
        code: '0038',
        parentCountyName: 'MIGUEL HIDALGO',
      },
      production: {
        name: 'Seleccion ubicacion',
        comunaName: '10 DE ABRIL',
        politicalId: 'b2557fa3-854b-45d4-8927-1de7ca49062d',
        priceGroupId: '1010',
        zones: [''],
        parentPoliticalId: '0bec7ea1-1d2e-43e0-bc4d-0f982e6d9ebb',
        parentStateId: '6cd56918-f632-41e2-af0d-66bdbde96e6a',
        parentStateName: 'MEXICO',
        latitude: 23.43338300413,
        longitude: -102.267439788865,
        code: '0038',
        parentCountyName: 'MIGUEL HIDALGO',
      },
      uat: {
        name: 'Seleccion ubicacion',
        comunaName: '10 DE ABRIL',
        politicalId: 'b2557fa3-854b-45d4-8927-1de7ca49062d',
        priceGroupId: '1010',
        zones: [''],
        parentPoliticalId: '0bec7ea1-1d2e-43e0-bc4d-0f982e6d9ebb',
        parentStateId: '6cd56918-f632-41e2-af0d-66bdbde96e6a',
        parentStateName: 'MEXICO',
        latitude: 23.43338300413,
        longitude: -102.267439788865,
        code: '0038',
        parentCountyName: 'MIGUEL HIDALGO',
      },
    },
  },
  ATC_SESSION_EXPIRED_CODE: 'CHECKOUT_INVALID_SESSION',
  RELATED_KEYWORDS_HEADING: 'Otras personas también buscaron:',
  CATEGORY: 'Categoría',
  ICON_CLASSES_MAPPING: {
    'f.range.product.averageOverallRating': 'csicon-star_full_filled star',
    'f.range.derived.product.averageOverallRating': 'csicon-star_full_filled star',
  },
  BRAND_FACET: /f.product.brandName/i,
  IS_USER_OVER_18: 'isUserOver18',
  SHIPPING_FACET_NAMES: ['Llega hoy', 'Llega mañana', 'Retira hoy', 'Retira mañana'],
  SB_EXPERIMENT_POSITION: 'RM_EXP_SB_EXPERIMENT_POSITION',
  SB_EXPERIMENT_MAX_ELEMENTS: 'RM_EXP_SB_EXPERIMENT_MAX_ELEMENTS',
  RM_EXP_SB_EXPERIMENT_NEW_STYLE: 'RM_EXP_SB_EXPERIMENT_NEW_STYLE',
  KIOSKO_STORE_ID: 'KIOSKO_STORE_ID',
  KIOSKO_MODULO: 'KIOSKO_MODULO',
  KIOSKO_INFO: 'KIOSKO_INFO',
  GOOGLE_AD_POSITION: { TOP: 'AD_UPPER_BANNER', SIDE: 'AD_SIDE_BANNER', BOTTOM: 'AD_BOTTOM_BANNER' },
  ALLOWED_XLP_GOOGLE_ADS: ['cortina de baño', 'cat690199', 'cat3205'],
  CART_DEFAULT_MESSAGE: 'Hubo un error al agregar el producto al carro',
  PAGE_NAME: {
    BRAND: 'brand',
    CATEGORY: 'category',
    COLLECTION: 'collection',
    NO_RESULT: 'noSearchResult',
    SEARCH: 'search',
    SELLER: 'seller',
    SHOP: 'shop',
  },
  DEFAULT_SPONSORED_BRAND_POSITION: {
    desktop: 4,
    mobile: 10,
    tablet: 10,
  },
  INSTALLMENT_WITHOUT_INTEREST_TEXT: 'cuotas sin interés CMR',
  PRICE_TYPE: {
    CMR: 'cmrPrice',
    EVENT: 'eventPrice',
    INTERNET: 'internetPrice',
    NORMAL: '"normalPrice"',
    CES: 'cesPrice',
    PRO: 'PRECIO+PRO',
    BULKPRICE: 'BULKPRICE',
  },
  CES_BADGE_LABEL: {
    CES_BLACK: 'CES BLACK',
    CES_ORO: 'CES ORO',
    CES_PLATA: 'CES PLATA',
  },
  USER_SEGMENT_COOKIE: 'userSegments',
  POPULAR_BRAND: 'mejores marcas',
  LO_ULTIMO: 'lo.último',
};
